// MUI computes derived palette values in JavaScript and cannot decompose CSS
// variable strings. These values mirror index.css and are guarded by
// themeTokens.test.js so the two public token surfaces cannot drift.
//
// One entry per mode, keyed identically, so createAppTheme() can index by mode
// and the mirror test can walk both sets against their :root blocks.
export const lightColors = {
  background: '#f4f7f4',
  surface: '#ffffff',
  surfaceMuted: '#eef3ef',
  text: '#16201a',
  textSoft: '#5c6b61',
  border: '#e1e7e2',
  accent: '#1f8a5b',
  accentStrong: '#1c8154',
  accentDark: '#14633f',
  accentSoft: '#e3f1e9',
  premium: '#6b4fc4',
  premiumSoft: '#efeafb',
  danger: '#b42318',
  onAccent: '#ffffff',
};

export const darkColors = {
  background: '#0d1210',
  surface: '#151b18',
  surfaceMuted: '#1d2521',
  text: '#e6ede8',
  textSoft: '#a1afa6',
  border: '#2b3630',
  accent: '#2b8f5e',
  accentStrong: '#45bd83',
  accentDark: '#6fd6a0',
  accentSoft: '#163023',
  premium: '#b9a3f7',
  premiumSoft: '#241d3c',
  danger: '#ff8b81',
  onAccent: '#04150e',
};

export const paletteFor = mode => (mode === 'dark' ? darkColors : lightColors);

// Retained so existing light-mode imports keep working.
export const designColors = lightColors;
